import { AfterViewInit, Component, ElementRef, ViewChild, ViewEncapsulation } from "@angular/core";

import { ICellEditorAngularComp } from "ag-grid-angular";

@Component({
    selector: 'datepicker-cell',
    templateUrl: 'g-datepicker.component.html',
    styleUrls: ['g-datepicker.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AGDatepickerEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: Date;

    @ViewChild('datepicker') public datepicker: ElementRef<HTMLElement>;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value ? new Date(this.params.value) : null;
    }

    getValue(): any {
        return this.value;
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.datepicker.nativeElement.focus();
        })
    }
}